export default __webpack_public_path__ + "static/media/Automatiza.e3aa1d3c.svg";